// extracted by mini-css-extract-plugin
export default {"shell":"App_shell__1G2Ca","placeholder":"App_placeholder__ppRZ8"};